import { Enumeration } from '../../utils/AppEnum';

export class Environment extends Enumeration<Environment> {

    public static Development = new Environment('DEV', 1);

    public static Testing = new Environment('TST', 2);

    public static Production = new Environment('PRD', 3);

    public static Lab = new Environment('LAB', 4);

    public static PoC = new Environment('PoC', 5);

    public static Acceptance = new Environment('ACC', 6);

}
